import { PhoneNumberFieldUiNewProps } from 'common/components/entities/Field/phone-number-field-ui'
import {
  backgroundColorCss,
  borderCss,
  boxShadowCss,
  fontCss,
  lineHeightCss,
  mobileBackgroundColorCss,
  mobileBorderCss,
  mobileBoxShadowCss,
  mobileFontCss,
  mobileLineHeightCss,
  mobilePaddingsCss,
  mobilePlaceholderColorCss,
  mobileTextAlignCss,
  paddingsCss,
  placeholderColorCss,
  textAlignCss,
} from 'common/utils/styleUtilsNew'
import { css } from 'styled-components'

const getMobileStyles = () => css<PhoneNumberFieldUiNewProps>`
  ${mobileFontCss}
  ${mobileLineHeightCss}
  ${mobileTextAlignCss}
  ${mobilePaddingsCss}
  ${mobileBackgroundColorCss}
  ${mobileBorderCss}
  ${mobilePlaceholderColorCss}
  ${mobileBoxShadowCss}
  ${p =>
    p.mobilePlaceholderColor &&
    css`
      &::placeholder {
        color: ${p.mobilePlaceholderColor};
      }
    `}
`

export const fieldStyles = () => css<PhoneNumberFieldUiNewProps>`
  width: 100%;
  font-size: 16px;
  padding: 12px 0;
  outline: none;
  text-indent: 10px;
  appearance: none;

  ${p =>
    p.hasIcon &&
    css`
      padding-right: ${(p.fontSize ?? 0) + 10}px;
    `};

  ${fontCss}
  ${lineHeightCss}
  ${textAlignCss}
  ${paddingsCss}
  ${backgroundColorCss}
  ${borderCss}
  ${placeholderColorCss}
  ${boxShadowCss}
  ${p =>
    p.hasErrors &&
    css`
      border-color: red;
    `}
  ${p =>
    p.placeholderColor &&
    css`
      &::placeholder {
        color: ${p.placeholderColor};
      }
    `}
  :disabled {
    opacity: 0.4;
  }

  ${p =>
    p.theme.isEditorMobileMode
      ? getMobileStyles()
      : css`
    ${p => p.theme.phone} {
      ${getMobileStyles()}
    }
  `}
`
